import { RoleCreate } from './RoleCreate'
import { RoleEdit } from './RoleEdit'
import { RoleList } from './RoleList'
import { RoleShow } from './RoleShow'

export { RoleCreate, RoleEdit, RoleList, RoleShow }
